<template>
    <div id="app">
        <a-config-provider :locale="locale">
            <router-view />
        </a-config-provider>
    </div>
</template>

<script>
    import zhCN from "ant-design-vue/es/locale-provider/zh_CN";
    import moment from "moment";
    import "moment/locale/zh-cn";
    moment.locale("zh-cn");

    export default {
        name: "App",
        data() {
            return {
                zhCN,
                locale: null,
                languageMap: {
                    "zh-cn": zhCN,
                },
            };
        },
        computed: {
            language: ({ $store }) => $store.state.language,
        },
        watch: {
            language: {
                handler() {
                    if (this.language == "en") {
                        moment.locale("en");
                        this.locale = null;
                    } else {
                        moment.locale("zh-cn");
                        this.locale = this.languageMap[this.language];
                    }
                    this.$i18n.locale = this.language;
                },
                deep: true,
                immediate: true,
            },
        },
        mounted() {

        },
    };
</script>

<style lang="less">
@import "~@/assets/css/common.less";
@import "~ant-design-vue/lib/style/themes/default.less"; // 引入官方提供的 less 样式入口文件
@import "~ant-design-vue/dist/antd.less"; // 引入官方提供的 less 样式入口文件
@import "~@/assets/css/antDefault.less";
body,
html,
#app {
    height: 100%;
    background: #F5F5F5;
    --antd-wave-shadow-color: transparent;
}

.el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    content: "";
}

.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue